export const getPreviewUrl = state => state.preview.previewUrl;
export const getPreviewDomain = state => {
  return state.preview.previewDomain;
};